// Regras puras do resultado do "Testar envio" da tela /messages-api.
// Separadas do componente para ficarem testáveis sem montar o React.
import { i18n } from "../../translate/i18n";

/**
 * Corpo da resposta formatado para o painel do drawer.
 *
 * Objeto vira JSON indentado; texto (uma página de erro do proxy, por
 * exemplo) sai como veio. `undefined` acontece quando a requisição nem
 * chegou ao servidor — aí não há corpo para mostrar.
 */
export const formatResponseBody = (body) => {
  if (body === undefined || body === null) return "";
  if (typeof body === "string") return body;
  try {
    return JSON.stringify(body, null, 2);
  } catch (err) {
    // Referência circular: melhor mostrar algo que engolir o resultado.
    return String(body);
  }
};

/**
 * Dica de correção a partir do status HTTP.
 *
 * Sem status (rede caiu, CORS, servidor fora) a dica é sobre conectividade —
 * dizer "campo inválido" ali mandaria a pessoa procurar no lugar errado.
 * Status desconhecido não ganha dica: um palpite genérico só ocupa espaço.
 */
export const dicaPorStatus = (status) => {
  if (!status) return i18n.t("aeros.api.result.hintNetwork");
  if (status === 401 || status === 403) return i18n.t("aeros.api.result.hint401");
  if (status === 422 || status === 400) return i18n.t("aeros.api.result.hint422");
  if (status === 429) return i18n.t("aeros.api.result.hint429");
  if (status >= 500) return i18n.t("aeros.api.result.hint500");
  return "";
};

// "200 OK · 412 ms" / "422 Unprocessable Entity · 88 ms · Comercial".
export const metaDoResultado = ({ status, statusText, ms, connectionName }) => {
  const codigo = status
    ? [status, statusText].filter(Boolean).join(" ")
    : i18n.t("aeros.api.result.noResponse");
  return [codigo, `${ms} ms`, connectionName].filter(Boolean).join(" · ");
};

/**
 * "agora" / "há 4 min" / "há 2 h" para o rótulo do último teste.
 *
 * Só a sessão atual alimenta esse estado, então o horizonte é curto de
 * propósito: acima de 24 h o rótulo some (devolve "") em vez de dizer
 * "há 37 h", que não ajuda ninguém.
 */
export const tempoRelativo = (at, agora = Date.now()) => {
  if (!at) return "";
  const minutos = Math.floor((agora - at) / 60000);
  if (minutos < 1) return i18n.t("aeros.api.result.justNow");
  if (minutos < 60) return i18n.t("aeros.api.result.minutesAgo", { count: minutos });
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return i18n.t("aeros.api.result.hoursAgo", { count: horas });
  return "";
};
